import { createActionsHook } from 'src/lib/sweetState';

import { ReadonlyDocumentScoresStore } from './ReadonlyDocumentScoresStore';

export const useReadonlyDocumentScoresActions = createActionsHook(ReadonlyDocumentScoresStore);
